<template>
    <base-modal title="Update Team" :visible="visible" @close="$emit('close')">
        <base-backend-errors :data="update.error"/>

        <base-loader v-if="detail.loading"/>

        <team-form
            v-else
            :init-data="detail.data"
            @submit="updateTeam"
            @cancel="$emit('close')"
            :loading="update.loading"/>
    </base-modal>
</template>

<script>
import { mapState } from 'vuex';
import TeamForm from './TeamForm.vue';

export default {
    name: 'TeamUpdate',
    components: { TeamForm },
    props: { visible: Boolean, team_id: Number },
    computed: mapState('teams', ['update', 'detail']),
    created() {
        this.$store.dispatch('teams/detail', { team_id: this.team_id });
    },
    methods: {
        updateTeam(data) {
            this.$store.dispatch('teams/update', {
                team_id: this.team_id,
                data,
            }).then(() => this.$emit('updated'));
        },
    },
};
</script>
